// extracted by mini-css-extract-plugin
export default {"wrapper":"Iha","container":"Jha","title":"Kha","carousel":"Lha","review":"Mha","name":"Nha","rating":"Oha","heading":"Pha","body":"Qha"};
    if(module.hot) {
      // 1738064244478
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  